import React, { Fragment, useEffect, useState } from "react";
import { Select as AntSelect } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { STEPS } from "../../../constants/enums";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import TextArea from "antd/es/input/TextArea";

const AuditUploadCertificate = (props: any) => {
  const { t, i18n } = useTranslation();
  const { setStep, summaryFormData, setSummaryFormData, handleSummarySubmit } =
    props;

  const { Option } = AntSelect;

  const navigate = useNavigate();

  return (
    <Fragment>
      <div className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10">
        <div>
          <div className="pw-input-label pw-create-label">
            Upload Certificate
          </div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {/* Lorem ipsum dolor sit amet. */}
              </p>
            </div>
          </div>
        </div>
        <div>
          <FileAttachmentsDetails
            formData={summaryFormData}
            setFormData={setSummaryFormData}
            externalVerifier={true}
          ></FileAttachmentsDetails>
        </div>
        <div className="w-full mt-4">
          <div className="pw-color-neutral-600 text-sm">Add Comments</div>
          <TextArea
            value={summaryFormData?.comments}
            onChange={(e) =>
              setSummaryFormData({
                ...summaryFormData,
                comments: e.target.value,
              })
            }
            placeholder="Comments"
            className="w-full pw-comments-field mt-1 p-4"
          />
          <div className="flex justify-end pw-color-neutral-400">0/100</div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold cursor-pointer"
          onClick={() => navigate("/log/Emissions")}
        >
          {t("Cancel")}
        </div>
        <button
          className={`pw-bunit-button-primary pw-bunit-button-save text-white bg-primary
          }`}
          onClick={handleSummarySubmit}
        >
          {t("Finish")}
        </button>
      </div>
    </Fragment>
  );
};

export default AuditUploadCertificate;
